import { useEffect, useState } from 'react';
import "./SSS.scss";
import DynamicDownloadBtnSection from '../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection';
import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const SSS = () => {

    const { backendUrl } = useContext(AppContext);
    const [allSSSReports, setAllSSSReports] = useState([]);
     let errorShown = false;

      async function fetchAllSSSReports() {
        try {
            const { data } = await axios.get(`${backendUrl}/api/auth/getAllSSS`);
            if (data.success) {
                setAllSSSReports(data || []);
            } 
            errorShown = false;  
            
        } catch (error) {
            if (errorShown) return;
            errorShown = true;
            if (error.response && error.response.status === 503) {
                            toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                        }
                        else if (!navigator.onLine) {
                            toast.error("🚫 No internet connection. Please check your network.");
                        }
            
                        else if (error.request && !error.response) {
                            toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                        }
                        else 
                        {
                            console.error("Unexpected error:", error);
                            toast.error("Something went wrong.");
                        }
        }
    }

    useEffect(() => {
        fetchAllSSSReports();
    }, [])

    const content = allSSSReports?.reports
        ?.filter(item => item.isActive)
        .map(item => ({
            filename: item.filename,
            data: item.data,
            contentType: item.contentType,
        })) || [];

    return (
        <section className="sssMainContainer">
            <header className="sssHeader">
                <h2>SSS</h2>
            </header>
            <DynamicDownloadBtnSection
                items={content}
                yearFontSize={1.25}
            />
        </section>
    )
}

export default SSS
